import React from 'react';

const BookmarkExistIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M15.9912 22.6217L9.49945 25.8643C9.00921 26.1304 8.39768 25.9527 8.12348 25.4645C8.0434 25.311 8.00106 25.1404 8 24.967V17.709C8 18.4286 8.40573 18.8728 9.47299 19.3702L15.9912 22.6217Z"
        fill="#000000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8953 6H19.0695C21.7773 6 23.9735 7.06605 24 9.79337V24.9668C23.9989 25.1374 23.9565 25.3051 23.8765 25.4554C23.7479 25.7007 23.5259 25.8827 23.2615 25.9598C22.997 26.0368 22.7128 26.0023 22.4741 25.8641L15.9912 22.6215L9.47299 19.3701C8.40573 18.8726 8 18.4284 8 17.7088V9.79337C8 7.06605 10.1963 6 12.8953 6ZM12.2249 13.6223H19.7486C20.1822 13.6223 20.5336 13.2683 20.5336 12.8316C20.5336 12.3949 20.1822 12.041 19.7486 12.041H12.2249C11.7914 12.041 11.4399 12.3949 11.4399 12.8316C11.4399 13.2683 11.7914 13.6223 12.2249 13.6223Z"
        fill="#000000"
      />
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#000000" />
    </svg>
  );
};

export default BookmarkExistIcon;
